import styled, { keyframes } from 'styled-components'
import * as TooltipPrimitive from '@radix-ui/react-tooltip'
import { media } from '../../../utils/mediaQuery'

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: scale(0.96);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
`

export const TooltipTrigger = styled.span`
  display: inline-flex;
`

export const TooltipContent = styled(TooltipPrimitive.Content).withConfig({
  shouldForwardProp: (prop) => prop !== '$maxWidth',
})<{ $maxWidth: number }>`
  z-index: ${({ theme }) => theme.zIndex.tooltip};
  max-width: ${({ $maxWidth }) => $maxWidth}px;
  padding: ${({ theme }) => `${theme.spacing.default} ${theme.spacing.medium}`};
  background: ${({ theme }) => theme.colors.background.primary};
  color: ${({ theme }) => theme.colors.text.primary};
  border: 1px solid ${({ theme }) => theme.colors.border.default};
  border-radius: ${({ theme }) => theme.borderRadius.large};
  box-shadow: ${({ theme }) => theme.shadows.lg};
  font-family: ${({ theme }) => theme.typography.fontFamily.sans};
  font-size: ${({ theme }) => theme.typography.fontSize.section};
  font-weight: ${({ theme }) => theme.typography.fontWeight.medium};
  line-height: 1.4;
  white-space: normal;
  overflow-wrap: break-word;
  pointer-events: none;
  /* Fade only the first open. A close animation keeps the previous tip mounted
     and stacks it on the next one. */
  animation: none;

  &[data-state='delayed-open'] {
    animation: ${fadeIn} 0.15s cubic-bezier(0.4, 0, 0.2, 1);
  }

  ${media.mobileOnly} {
    max-width: min(${({ $maxWidth }) => $maxWidth}px, 90vw);
  }
`
